import { Global, css } from '@emotion/react'

import nanumBarunGothicEot from '../fonts/NanumBarunGothic.eot'
import nanumBarunGothicTtf from '../fonts/NanumBarunGothic.ttf'
import nanumBarunGothicWoff from '../fonts/NanumBarunGothic.woff'
import nanumBarunGothicWoff2 from '../fonts/NanumBarunGothic.woff2'
import nanumBarunGothicBoldEot from '../fonts/NanumBarunGothicBold.eot'
import nanumBarunGothicBoldTtf from '../fonts/NanumBarunGothicBold.ttf'
import nanumBarunGothicBoldWoff from '../fonts/NanumBarunGothicBold.woff'
import nanumBarunGothicBoldWoff2 from '../fonts/NanumBarunGothicBold.woff2'
import nanumBarunGothicLightEot from '../fonts/NanumBarunGothicLight.eot'
import nanumBarunGothicLightTtf from '../fonts/NanumBarunGothicLight.ttf'
import nanumBarunGothicLightWoff from '../fonts/NanumBarunGothicLight.woff'
import nanumBarunGothicLightWoff2 from '../fonts/NanumBarunGothicLight.woff2'
import proximanovaRegularWebfontEot from '../fonts/proximanova-regular-webfont.eot'
import proximanovaRegularWebfontSvg from '../fonts/proximanova-regular-webfont.svg'
import proximanovaRegularWebfontTtf from '../fonts/proximanova-regular-webfont.ttf'
import proximanovaRegularWebfontWoff from '../fonts/proximanova-regular-webfont.woff'
import proximanovaRegularWebfontWoff2 from '../fonts/proximanova-regular-webfont.woff2'
import proximanovaSemiboldWebfontEot from '../fonts/proximanova-semibold-webfont.eot'
import proximanovaSemiboldWebfontSvg from '../fonts/proximanova-semibold-webfont.svg'
import proximanovaSemiboldWebfontTtf from '../fonts/proximanova-semibold-webfont.ttf'
import proximanovaSemiboldWebfontWoff from '../fonts/proximanova-semibold-webfont.woff'
import proximanovaSemiboldWebfontWoff2 from '../fonts/proximanova-semibold-webfont.woff2'
import Colors from './Colors'

export default function GlobalStyles() {
  return <Global styles={styles} />
}

const SCROLLBAR_WIDTH = '6px'

const styles = css`
  @font-face {
    font-family: 'Proxima Nova';
    src: url(${proximanovaRegularWebfontEot});
    src: url(${proximanovaRegularWebfontEot}) format('embedded-opentype'),
      url(${proximanovaRegularWebfontWoff2}) format('woff2'),
      url(${proximanovaRegularWebfontWoff}) format('woff'),
      url(${proximanovaRegularWebfontTtf}) format('truetype'),
      url(${proximanovaRegularWebfontSvg}) format('svg');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Proxima Nova';
    src: url(${proximanovaRegularWebfontEot});
    src: url(${proximanovaRegularWebfontEot}) format('embedded-opentype'),
      url(${proximanovaRegularWebfontWoff2}) format('woff2'),
      url(${proximanovaRegularWebfontWoff}) format('woff'),
      url(${proximanovaRegularWebfontTtf}) format('truetype'),
      url(${proximanovaRegularWebfontSvg}) format('svg');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Proxima Nova';
    src: url(${proximanovaSemiboldWebfontEot});
    src: url(${proximanovaSemiboldWebfontEot}) format('embedded-opentype'),
      url(${proximanovaSemiboldWebfontWoff2}) format('woff2'),
      url(${proximanovaSemiboldWebfontWoff}) format('woff'),
      url(${proximanovaSemiboldWebfontTtf}) format('truetype'),
      url(${proximanovaSemiboldWebfontSvg}) format('svg');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'nanum-barun-gothic';
    font-style: normal;
    font-weight: 300;
    src: url(${nanumBarunGothicLightEot});
    src: url(${nanumBarunGothicLightEot}) format('embedded-opentype'),
      url(${nanumBarunGothicLightWoff2}) format('woff2'),
      url(${nanumBarunGothicLightWoff}) format('woff'),
      url(${nanumBarunGothicLightTtf}) format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'nanum-barun-gothic';
    font-style: normal;
    font-weight: 400;
    src: url(${nanumBarunGothicEot});
    src: url(${nanumBarunGothicEot}) format('embedded-opentype'),
      url(${nanumBarunGothicWoff2}) format('woff2'), url(${nanumBarunGothicWoff}) format('woff'),
      url(${nanumBarunGothicTtf}) format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'nanum-barun-gothic';
    font-style: normal;
    font-weight: 600;
    src: url(${nanumBarunGothicBoldEot});
    src: url(${nanumBarunGothicBoldEot}) format('embedded-opentype'),
      url(${nanumBarunGothicBoldWoff2}) format('woff2'),
      url(${nanumBarunGothicBoldWoff}) format('woff'),
      url(${nanumBarunGothicBoldTtf}) format('truetype');
    font-display: swap;
  }

  html {
    font-family: 'Proxima Nova';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;

    &[lang='ja'] {
      font-family: 'Proxima Nova', 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', 'メイリオ',
        'MS PGothic', Meiryo, Osaka, sans-serif;
    }

    &[lang='ko'] {
      font-family: 'Proxima Nova', nanum-barun-gothic, 'Avenir Next', 'Segoe UI', Helvetica, Arial,
        sans-serif;
    }

    &[lang='th'] {
      font-family: 'Proxima Nova', 'Leelawadee UI', sans-serif;
    }
  }

  body {
    background: white;
    color: ${Colors.Gray600};
  }

  a {
    cursor: pointer;
    text-decoration: none;
  }

  button {
    cursor: pointer;

    &:disabled {
      cursor: default;
    }
  }

  input[type='search']::-webkit-search-decoration,
  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-results-button,
  input[type='search']::-webkit-search-results-decoration {
    display: none;
  }

  .js-focus-visible *:focus:not(.focus-visible) {
    outline: none;
  }
  :focus {
    outline: 3px auto ${Colors.Gray300};
  }
  ::-webkit-scrollbar {
    width: ${SCROLLBAR_WIDTH};
    height: ${SCROLLBAR_WIDTH};
    background: ${Colors.Gray50};
  }
  ::-webkit-scrollbar-thumb {
    border-radius: calc(${SCROLLBAR_WIDTH} / 2);
    background: ${Colors.Gray300};
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${Colors.Gray400};
  }
  ::-webkit-scrollbar-thumb:active {
    background: ${Colors.Gray500};
  }

  .ReactModal__Overlay {
    opacity: 0;
    transition: opacity 150ms ease-in-out;
  }

  .ReactModal__Overlay--after-open {
    opacity: 1;
  }

  .ReactModal__Overlay--before-close {
    opacity: 0;
  }
`
